import React, { Component } from 'react';
import { func, object, string } from 'prop-types';
import classNames from 'classnames';

import { injectIntl, intlShape } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import { formatMoney } from '../../../util/currency';
import { ensureListing } from '../../../util/data';

import css from './SearchMapQuantityLabel.module.css';

const MAP_VARIANT_DEALER_LOCATOR = 'dealerLocator';

class SearchMapQuantityLabel extends Component {
  shouldComponentUpdate(nextProps) {
    const currentListing = ensureListing(this.props.listing);
    const nextListing = ensureListing(nextProps.listing);
    const isSameListing = currentListing.id.uuid === nextListing.id.uuid;
    const hasSameRefreshToken =
      this.props.mapComponentRefreshToken === nextProps.mapComponentRefreshToken;
    const hasSameActiveStatus = this.props.isActive === nextProps.isActive;
    const hasSameMapVariant = this.props.mapVariant === nextProps.mapVariant;

    return !(isSameListing && hasSameRefreshToken && hasSameActiveStatus && hasSameMapVariant);
  }

  render() {
    const {
      className,
      rootClassName,
      intl,
      listing,
      onListingClicked,
      isActive,
      config,
      mapVariant,
    } = this.props;
    const currentListing = ensureListing(listing);
    const { totalListings } = currentListing;
    const isDealerMarker = !!currentListing.store && totalListings == null;
    const isActiveDealerMarker = isDealerMarker && isActive && mapVariant === MAP_VARIANT_DEALER_LOCATOR;
    const labelValue = isDealerMarker ? '' : totalListings;

    const classes = classNames(rootClassName || css.root, className);
    const priceLabelClasses = classNames(css.priceLabel, {
      [css.mapLabelActive]: isActive,
      [css.noPriceSetLabel]: !totalListings,
      [css.dealerMarkerLabel]: isDealerMarker,
      [css.dealerMarkerActiveLabel]: isActiveDealerMarker,
    });
    const caretClasses = classNames(css.caret, {
      [css.caretActive]: isActive,
      [css.dealerMarkerActiveCaret]: isActiveDealerMarker,
    });

    return (
      <button className={classes} onClick={() => onListingClicked(currentListing)}>
        <div className={css.caretShadow} />
        <div className={priceLabelClasses}>{labelValue}</div>
        <div className={caretClasses} />
      </button>
    );
  }
}

SearchMapQuantityLabel.defaultProps = {
  className: null,
  rootClassName: null,
};

SearchMapQuantityLabel.propTypes = {
  className: string,
  rootClassName: string,
  listing: propTypes.listing.isRequired,
  onListingClicked: func.isRequired,
  config: object.isRequired,
  mapVariant: string,

  // from injectIntl
  intl: intlShape.isRequired,
};

export default injectIntl(SearchMapQuantityLabel);
